<template>
  <footer class="beast-main-footer">
    <div class="container">
      <div class="row">
        <div class="col-4 text-left">
          <div class="beast-logo">beast repository</div>

          <div class="beast-copyright">
            2018 &copy; <a href="https://wayfare.ro" target="_blank">Wayfare SRL</a>. All rights reserved
            <br/>
            Version: v{{version}} <span v-show="build !== ''"># {{build}}</span>
          </div>
        </div>
        <div class="offset-6 col-2 beast-useful-links">
          <h3>Useful links</h3>
          <ul>
            <li>
              <router-link to="/dms/pages/documentation">
                Documentation
              </router-link>
            </li>
            <li>
              <router-link to="/dms/pages/about-app">
                About App
              </router-link>
            </li>
            <li>
              <router-link to="/dms/pages/contribute">
                Contribute
              </router-link>
            </li>
            <li>
              <router-link to="/dms/pages/report-bugs">
                Report Bugs
              </router-link>
            </li>
            <li>
              <router-link to="/dms/pages/terms-of-use">
                Terms of use
              </router-link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "BeastFooter",

  computed: {
    version() {
      return this.$beast.version;
    },
    build() {
      return this.$beast.build;
    }
  }
};
</script>

<style scoped lang="scss">
  footer {
    padding: 25px 0;
  }

  .beast-logo {
    vertical-align: middle;
    display: block;
    width: 150px;
    height: 50px;
    text-align: center;
    text-indent: -5000px;
    background: transparent url("../../assets/beast_logo_white.png") no-repeat left center;
    background-size: contain;
  }

  .beast-copyright {
    margin: 5px auto 5px 5px;
  }

  .beast-useful-links {
    text-align: left;
    h3 {
      font-size: 14pt;
      font-weight: bold;
    }

    ul {
      list-style: none;
      padding: 0;
      margin: 0;

      a {
        color: #ababab;
      }
    }

  }

</style>
